const industries = [
  'Aggregate',
  'Agriculture Contractor',
  'Bulk',
  'Bus & Coach (Urban)',
  'Bus & Coach (School)',
  'Bus & Coach (Tour)',
  'Car haul',
  'Cars and Van',
  'Chemicals',
  'Civil Contractor',
  'Civil Works',
  'Traffic Control',
  'Concrete',
  'Containers',
  'Combination Fleet Operator',
  'Furniture Removal',
  'Gas and Petroleum',
  'Milk Tankers',
  'General Freight',
  'Ground spreading',
  'Grain Carrier',
  'Heavy Haulage',
  'Linehaul',
  'Livestock',
  'Logging',
  'Plant and Machinery',
  'Refrigerated',
  'Refuse/Waste',
  'Soil, Sand and Gravel',
  'Taxi Light Car & Mini Van/Shuttles',
  'Vehicle Recovery',
  'Vehicle Rental'
];
industries.sort();
industries.push('Other');

const countries = [
  'Australia',
  'New Zealand'
];

const regions = {
  Australia: [
    'New South Wales',
    'Northern Territory',
    'Queensland',
    'South Australia',
    'Tasmania',
    'Victoria',
    'Western Australia'
  ],
  'New Zealand': [
    'Northland',
    'Auckland',
    'Waikato',
    'Bay of Plenty',
    'Gisborne',
    'Hawke\'s Bay',
    'Taranaki',
    'Manawatu-Whanganui',
    'Wellington',
    'Tasman',
    'Nelson',
    'Marlborough',
    'West Coast',
    'Cantebury',
    'Otago',
    'Southland'
  ]
};

const getRegions = country => regions[country];

// gear definitions
const gearDef = {
  0: 1,
  60: 2,
  70: 3,
  80: 4
};

export {
  industries,
  countries,
  regions,
  getRegions,
  gearDef
};



// WEBPACK FOOTER //
// ./src/services/constants.js